/** Read a File as a data URL (used for anonymous users who can't upload to S3). */
export const loadImageAsDataUrl = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      if (typeof reader.result === 'string') resolve(reader.result)
      else reject(new Error('FileReader returned non-string'))
    }
    reader.onerror = () => reject(reader.error ?? new Error('FileReader failed'))
    reader.readAsDataURL(file)
  })

/** Resolve the natural width / height ratio of an image at the given URL. */
export const measureImageAspect = (url: string): Promise<number> =>
  new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const w = img.naturalWidth || 1
      const h = img.naturalHeight || 1
      resolve(w / h)
    }
    img.onerror = () => reject(new Error('Failed to load image for aspect measurement'))
    img.src = url
  })
